var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIce2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 498,
    height: 272,
    viewBox: "0 0 498 272",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478.336 110.417L452.432 59.9552L363.746 19.0811H143.522L123.968 40.4432V55.792L112.614 52.8484L18.9231 78.9204V121.687L91.6723 168.574L131.537 231.189L249.113 248.262L269.046 221.349L263.074 252.593L360.718 246.286L415.511 168.616L478.294 153.268V110.501L478.336 110.417ZM415.553 125.808L361.517 202.342L415.553 125.766V125.808Z",
    fill: "#00E7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6723 125.766L57.19 103.521M155.801 191.913L249.113 205.453L269.046 178.541M264.504 202.3L263.074 209.785M302.855 207.22L360.76 203.477M415.553 125.766L361.517 202.342L415.553 125.808V125.766ZM415.553 125.766L477.117 110.711M478.336 110.417L452.432 59.9552L363.746 19.0811H143.522L123.968 40.4432V55.7921L112.614 52.8484L18.9231 78.9204V121.687L91.6723 168.574L131.537 231.189L249.113 248.262L269.046 221.349L263.074 252.593L360.718 246.286L415.511 168.616L478.294 153.268V110.501L478.336 110.417Z",
    stroke: "#00E7F9",
    strokeWidth: 37.8464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.579 188.337V231.145L249.155 248.176V205.41L131.579 188.337Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.715 125.761V168.528L131.58 231.142V188.334L91.715 125.761Z",
    fill: "#9BD6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9642 78.8379V121.604L91.7134 168.534V125.767L18.9642 78.8379Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.76 203.43V246.197L415.595 168.528V125.761L360.76 203.43Z",
    fill: "#E6F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.596 125.767V168.534L478.379 153.143V110.376L415.596 125.767Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.377 110.375L415.594 125.766L360.759 203.435L269.087 209.364L263.115 209.743L269.087 178.499L249.154 205.411L131.536 188.381L91.7134 125.766L18.9642 78.8364L112.613 52.7644L123.967 55.7501V40.4012L143.521 19.0391H363.787L452.432 59.9132L478.377 110.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.296 71.8151L166.44 78.8377L151.47 62.9002L123.968 55.7514V40.4026L163.454 57.896L172.411 71.8151H205.296Z",
    fill: "#9BD6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.116 209.743L269.087 178.499L249.155 205.412V248.178L269.087 221.265V209.364L263.116 209.743Z",
    fill: "#9BD6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.116 209.742L269.087 209.364L263.116 209.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.116 209.743L269.087 221.265L263.116 252.509L360.76 246.201V203.435L263.116 209.743Z",
    fill: "#BBE4F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 497.259,
    height: 271.317,
    fill: "white",
    transform: "translate(0 0.158203)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIce2);
export default __webpack_public_path__ + "static/media/ice-2.svg";
export { ForwardRef as ReactComponent };